var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoData = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 117,
    viewBox: "0 0 83 117",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.003 31.21C16.467 29.877 5.895 25.906 5.895 21.178c0-5.774 15.933-10.466 35.605-10.466 19.671 0 35.605 4.692 35.605 10.466 0 4.729-10.572 8.699-25.146 10.034M51.21 10.71C51.21 5.35 46.861 1 41.5 1c-5.362 0-9.71 4.35-9.71 9.71",
    stroke: "#484542",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.026 22.578-34.526 82M82.499 104.578l-34.526-82",
    stroke: "#484542",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3 4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.5,
    cy: 104.579,
    rx: 41,
    ry: 11.868,
    stroke: "#484542",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3 4"
  })));
};
export default SvgNoData;